<template>
  <div class="container-fluid section">
      <div class="row">
        <div class="col">
          <h2>Saved Reports</h2>
        </div>
      </div>
    <div class="row lined" v-for="report in reports" :key="report.userReport_id">
      <div class="col" >
        <a class="report-link" @click="goToReport(report)">
          {{ report.name}}
        </a>
      </div>
      <div class="col text-right">
        <dropdown-confirmation
          triggerBtnClass="btn-delete btn-sm"
          triggerBtnHtml='<i class="fa fa-trash"></i>'
          confirmBtnClass="btn-danger"
          confirmBtnHtml='<i class="fa fa-remove"></i>&nbsp;&nbsp;Delete'
          @confirm="deleteReport(report)"
        ></dropdown-confirmation>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
  export default {
    name: 'SavedReports',
    data: function () {
      return {
        reports: []
      }
    },
    components: {
      DropdownConfirmation
    },
    created(){
      this.fetchData();
    },
    methods:{
      goToReport(report) {
        var url = report.reportString + '&userReport_id=' + report.userReport_id + '&report_name='+ encodeURI(report.name);

        this.$router.push(url);

      },
      deleteReport(report){
        this.$send(this, 'userReportDelete',report).then(r => {
          this.fetchData();
        });

      },

      fetchData(){

        this.$send(this, 'userReports').then(r => {
          this.reports = r.userReports;
        });

      }
    }

  }


</script>
<style scoped>
  .report-link{
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// SavedReports.vue?2d249152